import { render, staticRenderFns } from "./MyProjects.vue?vue&type=template&id=157876cf&scoped=true&"
import script from "./MyProjects.vue?vue&type=script&lang=js&"
export * from "./MyProjects.vue?vue&type=script&lang=js&"
import style0 from "./MyProjects.vue?vue&type=style&index=0&id=157876cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157876cf",
  null
  
)

export default component.exports